import React from "react";
import "./style.css";

// images
// src\assets\images\photography\img0.webp
import img0 from "../../assets/images/photography/img0.webp";
import img1 from "../../assets/images/photography/img1.webp";
import img2 from "../../assets/images/photography/img2.webp";
import img3 from "../../assets/images/photography/img3.webp";
import img4 from "../../assets/images/photography/img4.webp";
import img5 from "../../assets/images/photography/img5.webp";
import img6 from "../../assets/images/photography/img6.webp";
import img7 from "../../assets/images/photography/img7.webp";
import img8 from "../../assets/images/photography/img8.webp";
import img9 from "../../assets/images/photography/img9.webp";
import img10 from "../../assets/images/photography/img10.webp";
import img11 from "../../assets/images/photography/img11.webp";
import img12 from "../../assets/images/photography/img12.webp";
import img13 from "../../assets/images/photography/img13.webp";
import img14 from "../../assets/images/photography/img14.webp";
import img15 from "../../assets/images/photography/img15.webp";
import img16 from "../../assets/images/photography/img16.webp";
import img17 from "../../assets/images/photography/img17.webp";
import img18 from "../../assets/images/photography/img18.webp";

import Navigation from "../../components/Navigation";
import { Helmet } from "react-helmet-async";

const portfolioItems = [
	// {
	// 	id: 0,
	// 	image: img0,
	// 	description: "",
	// },
	{
		id: 1,
		image: img1,
		description: "",
	},
	{
		id: 2,
		image: img2,
		description: "",
	},
	{
		id: 3,
		image: img3,
		description: "",
	},
	{
		id: 4,
		image: img4,
		description: "",
	},
	{
		id: 5,
		image: img5,
		description: "",
	},
	// {
	// 	id: 6,
	// 	image: img6,
	// 	description: "",
	// },
	{
		id: 7,
		image: img7,
		description: "",
	},
	{
		id: 8,
		image: img8,
		description: "",
	},
	{
		id: 9,
		image: img9,
		description: "",
	},
	{
		id: 10,
		image: img10,
		description: "",
	},
	{
		id: 11,
		image: img11,
		description: "",
	},
	// {
	// 	id: 12,
	// 	image: img12,
	// 	description: "",
	// },
	{
		id: 13,
		image: img13,
		description: "",
	},
	{
		id: 14,
		image: img14,
		description: "",
	},
	{
		id: 15,
		image: img15,
		description: "",
	},
	{
		id: 16,
		image: img16,
		description: "",
	},
	{
		id: 17,
		image: img17,
		description: "",
	},
	{
		id: 18,
		image: img18,
		description: "",
	},
];

const Photography = () => {
	return (
		<div className="collection-container">
			{/* <Sidebar currentPage="/collection" /> */}

			<main className="collection-main">
				<Navigation />
				<Helmet>
					<title>Photography Portfolio - Big Cat Graphics</title>
					<meta name="description" content="Explore the photography portfolio of Big Cat Graphics, showcasing a diverse range of captivating images that demonstrate creativity and technical skills in digital art." />
				</Helmet>
				<div className="threeD-header" style={{backgroundImage: `url(${img1})`}}>
					<h1 className="threeD-title">Photography Portfolio</h1>
					<p className="threeD-subtitle">
						A showcase of my photography projects, demonstrating creativity and technical skills in
						digital art.
					</p>
				</div>

				{/* Portfolio Grid */}
				<section className="threeD-wrapper">
					<div className="threeD-grid">
						{portfolioItems.map((item) => (
							<div key={item.id} className="threeD-item">
								<img
									src={item.image}
									alt={`${item.title} - ${item.category}`}
									className="threeD-image"
								/>
								<div className="threeD-overlay">
									<div className="threeD-text">
										<h3>{item.title}</h3>
										<p>{item.category}</p>
									</div>
								</div>
							</div>
						))}
					</div>
				</section>
			</main>
		</div>
	);
};

export default Photography;